import React from "react";
import copy from "../copy";

// Common frame for every step: title, optional subtitle, content, back link.
const StepShell = ({ title, subtitle, onBack, className = "", children }) => (
  <section className={`rp-step ${className}`.trim()}>
    {title && <h1 className="rp-title">{title}</h1>}
    {subtitle && <p className="rp-subtitle">{subtitle}</p>}
    {children}
    {onBack && (
      <button type="button" className="rp-back" onClick={onBack}>
        {copy.back}
      </button>
    )}
  </section>
);

export default StepShell;
